import { Wrapper, Divider } from '@farewill/ui'
import { useFormikContext } from 'formik'

import RequestStatus from 'components/request-status'
import { BRAND_ID } from 'config/brands'
import { FuneralAttributes } from 'lib/models/funeral'
import withForm from 'routes/probate-estate/fact-find/components/with-form'

import Customer from './customer'
import PersonWhoHasDied from './person-who-has-died'
import CircumstancesOfDeath from './circumstances-of-death'
import DoctorsAndMedical from './doctors-and-medical'
import Funeral from './funeral'
import IsProbateNeeded from './is-probate-needed'
import SigningTheForms from './signing-the-forms'
import InternalNotes from './internal-notes'
import { SaveProp } from './types'

const FactFind = ({
  funeralId,
  saveContactField,
  saveFuneralField,
  saveFuneralFields,
}: {
  funeralId: number
  saveContactField: SaveProp
  saveFuneralField: SaveProp
  saveFuneralFields: (attributes: FuneralAttributes) => void
}): React.ReactElement => {
  const {
    values: {
      contact: { brandId },
    },
  } = useFormikContext<{ contact: { brandId: string } }>()
  const isFarewillBrand = brandId === BRAND_ID.farewill

  return (
    <Wrapper>
      <RequestStatus />
      <Wrapper>
        <Customer
          saveContactField={saveContactField}
          saveFuneralField={saveFuneralField}
        />
      </Wrapper>
      <Divider separator />
      <Wrapper separator>
        <PersonWhoHasDied handleSave={saveFuneralField} />
      </Wrapper>
      <Divider separator />
      <Wrapper separator>
        <CircumstancesOfDeath handleSave={saveFuneralField} />
      </Wrapper>
      <Divider separator />
      <Wrapper separator>
        <DoctorsAndMedical handleSave={saveFuneralField} />
      </Wrapper>
      <Divider separator />
      <Wrapper separator>
        <Funeral
          handleSave={saveFuneralField}
          saveFuneralFields={saveFuneralFields}
        />
      </Wrapper>
      {/* We only cross-sell probate for Farewill */}
      {isFarewillBrand && (
        <>
          <Divider separator />
          <Wrapper separator>
            <IsProbateNeeded
              funeralId={funeralId}
              handleSave={saveFuneralField}
            />
          </Wrapper>
        </>
      )}
      <Divider separator />
      <Wrapper separator>
        <SigningTheForms handleSave={saveFuneralField} />
      </Wrapper>
      <Divider separator />
      <Wrapper separator>
        <InternalNotes handleSave={saveFuneralField} />
      </Wrapper>
    </Wrapper>
  )
}

export default withForm(FactFind)
